import { render } from "./AppBackground.vue?vue&type=template&id=0db1f6ba"
import script from "./AppBackground.vue?vue&type=script&lang=js"
export * from "./AppBackground.vue?vue&type=script&lang=js"

import "./AppBackground.vue?vue&type=style&index=0&id=0db1f6ba&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__